import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  MarketingTemplate,
  UpsertMarketingTemplatePayload
} from "../../marketing.types";
import { requestUpsertMarketingTemplate } from "./upsertMarketingTemplate.request";

const useUpsertMarketingTemplate = (
  options?: MutationOptions<
    MarketingTemplate,
    ApiServiceError<ApiError>,
    UpsertMarketingTemplatePayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpsertMarketingTemplate,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "templates"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpsertMarketingTemplate;
